'use client';
import { useContext } from 'react';
import Partials from 'components/partials/Partials';
import { AppContext } from 'context/AppContext';
import type { PartialWidgetContext } from 'types/cms';
import { getKey } from 'utils/idGenerator';
import styles from './combi-ad.module.scss';

export type GroupGridProps = {
  readonly children: Array<PartialWidgetContext>;
};

export const GroupGridCombiAd = ({ context }: { context: GroupGridProps }) => {
  const {
    pageMetaData: { noAds },
  } = useContext(AppContext);

  if (noAds) {
    return null;
  }

  return (
    <div className={styles.combiAd}>
      <span>Anzeige:</span>
      <div className={styles.wrapper}>
        <div className={styles.title}>Empfehlungen unserer Partner</div>
        {context.children.map((widget: PartialWidgetContext) => (
          <Partials key={getKey(widget.id, widget)} context={widget} />
        ))}
      </div>
    </div>
  );
};
